import {
  getVerificationStatus,
  sendVerificationEmail,
  resendVerificationEmail,
  verifyEmail,
} from "./asyncThunks";

export const emailVerificationBuilder = (builder) => {
  builder
    // Get verification status
    .addCase(getVerificationStatus.pending, (state) => {
      state.status.loading = true;
      state.status.error = null;
    })
    .addCase(getVerificationStatus.fulfilled, (state, action) => {
      state.status.loading = false;
      state.status.error = null;
      state.data = action.payload;
    })
    .addCase(getVerificationStatus.rejected, (state, action) => {
      state.status.loading = false;
      state.status.error = action.payload;
    })

    // Send verification email
    .addCase(sendVerificationEmail.pending, (state) => {
      state.sendEmail.loading = true;
      state.sendEmail.error = null;
    })
    .addCase(sendVerificationEmail.fulfilled, (state, action) => {
      state.sendEmail.loading = false;
      state.sendEmail.error = null;
      state.sendEmail.success = true;
      state.sendEmail.message = action.payload.message;
    })
    .addCase(sendVerificationEmail.rejected, (state, action) => {
      state.sendEmail.loading = false;
      state.sendEmail.error = action.payload;
      state.sendEmail.success = false;
    })

    // Resend verification email
    .addCase(resendVerificationEmail.pending, (state) => {
      state.resendEmail.loading = true;
      state.resendEmail.error = null;
    })
    .addCase(resendVerificationEmail.fulfilled, (state, action) => {
      state.resendEmail.loading = false;
      state.resendEmail.error = null;
      state.resendEmail.success = true;
      state.resendEmail.message = action.payload.message;
    })
    .addCase(resendVerificationEmail.rejected, (state, action) => {
      state.resendEmail.loading = false;
      state.resendEmail.error = action.payload;
      state.resendEmail.success = false;
    })

    // Verify email
    .addCase(verifyEmail.pending, (state) => {
      state.verify.loading = true;
      state.verify.error = null;
    })
    .addCase(verifyEmail.fulfilled, (state, action) => {
      state.verify.loading = false;
      state.verify.error = null;
      state.verify.success = true;
      state.verify.user = action.payload.user;
      // Update main data if verification was successful
      if (state.data) {
        state.data.emailVerified = true;
        state.data.needsVerification = false;
      }
    })
    .addCase(verifyEmail.rejected, (state, action) => {
      state.verify.loading = false;
      state.verify.error = action.payload;
      state.verify.success = false;
    });
};